import { Navigate } from "react-router";

import { useAuth } from "@/components/lib/auth";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";

function AuthDashboard() {
  const { currentWorkspace, currentUser } = useAuth();

  if (!currentUser.name) {
    return <Navigate to="/onboard" />;
  }

  return (
    <>
      {currentWorkspace.isPersonal ? (
        <Navigate to="/coaching" replace />
      ) : (
        <Navigate to="/home" replace />
      )}
    </>
  );
}

export function DashboardPage() {
  return (
    <Authenticate layout="dashboard" showMessageBar={false}>
      <AuthDashboard />
    </Authenticate>
  );
}
